import { ETIQUETAS_ESTADO_CITA, type EstadoCita as Estado } from '@barbones/shared';
import { CalendarCheck, CircleSlash, Clock3, HandCoins, Hourglass, Scissors, UserX } from 'lucide-react';
import { Insignia } from '@/components/ui/data';

const ESTILO: Record<Estado, { tono: 'neutro' | 'acento' | 'exito' | 'aviso' | 'peligro' | 'info' | 'solido'; icono: typeof Clock3 }> = {
  agendada: { tono: 'info', icono: CalendarCheck },
  en_tolerancia: { tono: 'aviso', icono: Hourglass },
  en_servicio: { tono: 'acento', icono: Scissors },
  por_cobrar: { tono: 'solido', icono: HandCoins },
  finalizada: { tono: 'exito', icono: Clock3 },
  cancelada: { tono: 'neutro', icono: CircleSlash },
  no_show: { tono: 'peligro', icono: UserX },
};

/** Estado de la cita con color, icono y texto (nunca solo color). */
export function EstadoCita({ estado }: { estado: Estado }) {
  const { tono, icono: Icono } = ESTILO[estado];
  return (
    <Insignia tono={tono}>
      <Icono aria-hidden />
      {ETIQUETAS_ESTADO_CITA[estado]}
    </Insignia>
  );
}

/** Clases de la tarjeta de cita en la vista de día, según su estado. */
export const CLASES_TARJETA: Record<Estado, string> = {
  agendada: 'border-l-info bg-info-soft/70',
  en_tolerancia: 'border-l-warning bg-warning-soft',
  en_servicio: 'border-l-accent bg-accent-soft',
  por_cobrar: 'border-l-primary bg-muted',
  finalizada: 'border-l-success bg-success-soft/70',
  cancelada: 'border-l-border bg-surface-alt opacity-60 line-through decoration-foreground-muted/50',
  no_show: 'border-l-destructive bg-destructive-soft/70 opacity-75',
};
